import type { ProviderKey } from "./components/SetupConsole";

// Who the welcome questionnaire's answers say belongs on the MCP connector
// path, shared so the onboarding guide and the completion gate cannot drift
// apart. They did once: the guide routed on "claude-cowork" and so did the
// gate, and adding ChatGPT to only one of them would have handed ChatGPT users
// the celebration screen with no platforms connected.
//
// Cowork and ChatGPT qualify because the connector is their only way in.
// Codex does not: it defaults to the CLI path (with a link across to the
// connector), and gating a pure-CLI Codex user on relay + platform logins
// would hold them back from a finish line they already crossed.
export function checkIsConnectorUser(tools: string[]): boolean {
  return tools.includes("claude-cowork") || tools.includes("chatgpt");
}

// Which provider tab the connector card opens on. Cowork wins when several are
// ticked: it is the answer that says "no terminal", so it is the strongest
// signal that the connector is the surface this person actually wants.
export function deriveConnectorProvider(tools: string[]): ProviderKey {
  if (tools.includes("claude-cowork")) return "claude";
  if (tools.includes("chatgpt")) return "chatgpt";
  if (tools.includes("codex")) return "codex";
  return "claude";
}
